import camelCase from 'lodash/camelCase'

const getCamelCaseKeys = (obj: any): any => {
  return Object.keys(obj).reduce(
    (acc, key) => ({
      ...acc,
      ...{ [camelCase(key)]: obj[key] },
    }),
    {},
  )
}

export default getCamelCaseKeys
